import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Loader, Message } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import LaunchContextService from '../services/LaunchContextService';

export default
@inject('userManager')
@observer
class FileViewerLaunch extends Component {
  constructor(props) {
    super(props);

    this.FileViewerModal = SatCoreComponent('FileViewerModal');
    this.state = {
      error: null,
      fallbackRoute: '/',
      isLoading: true,
      modalState: null
    };
  }

  componentDidMount() {
    this.bootstrapLaunchContext();
  }

  bootstrapLaunchContext = () => {
    const { location } = this.props;
    const params = new URLSearchParams(location?.search);
    const launchId = params.get('fileViewerLaunchId');

    if (!launchId) {
      this.setState({
        error: 'Missing fileViewerLaunchId parameter. Please restart the launch workflow.',
        isLoading: false
      });
      return;
    }

    const context = LaunchContextService.consumeContext(launchId);
    if (!context || !(context.fileViewerUrl || context.modalState?.url)) {
      this.setState({
        error: 'Launch information has expired. Please retry from the original tab.',
        isLoading: false
      });
      return;
    }

    this.setState({
      fallbackRoute: context.meta?.sourceRoute || '/',
      isLoading: false,
      modalState: {
        ...context.modalState,
        url: context.modalState?.url || context.fileViewerUrl
      }
    });
  }

  handleClose = () => {
    const { history, location } = this.props;
    const { fallbackRoute } = this.state;
    const params = new URLSearchParams(location?.search);
    const launchedViaParam = params.has('fileViewerLaunchId');

    if (launchedViaParam) {
      window.close();
      return;
    }

    if (window.opener) {
      window.close();
      return;
    }

    history.replace(fallbackRoute || '/');
  }

  renderError = () => {
    const { error } = this.state;
    return (
      <Message
        content={error || 'Unable to load resource.'}
        negative />
    );
  }

  render() {
    const { FileViewerModal } = this;
    const { userManager } = this.props;
    const { error, isLoading, modalState } = this.state;

    if (isLoading) {
      return (
        <div className='fileviewer-launch-loading'>
          <Loader active inline='centered' size='large'>Preparing resource…</Loader>
        </div>
      );
    }

    if (error || !modalState) {
      return this.renderError();
    }

    return (
      <div className='fileviewer-launch-container'>
        <FileViewerModal
          assignmentId={modalState.assignmentId}
          closeModalCallback={this.handleClose}
          contentImageUrl={modalState.contentImageUrl}
          contentMode={modalState.contentMode}
          contentName={modalState.contentName}
          contentType={modalState.contentType}
          instruction={modalState.instruction}
          isFlowpaper={modalState.isFlowpaper}
          isTeacher={userManager.isTeacher}
          page='file-viewer'
          resourceName={modalState.resourceName}
          url={modalState.url} />
      </div>
    );
  }
}

SatCoreRegister('FileViewerLaunch', FileViewerLaunch);

